import React from 'react';
import { Select } from 'antd';
import Field from '../../../../shared/ui/Field';
import {
  useFieldController,
  useFormMethods,
} from '../../../../../../helpers/formManager';
import { dateSettingValueEnum, fieldNames } from '../../constants';
import styles from './index.module.scss';

const options = [
  { label: 'Дату начала', value: dateSettingValueEnum.START_DATE },
  { label: 'Дату окончания', value: dateSettingValueEnum.END_DATE },
  { label: 'Период', value: dateSettingValueEnum.PERIOD },
];

const unregisteredNames = [fieldNames.startDate, fieldNames.endDate];

const SelectDateSetting = () => {
  const { field, fieldState } = useFieldController({
    name: fieldNames.dateSetting,
    rules: { required: 'Укажите, что устанавливать' },
  });

  const { unregister } = useFormMethods();

  const handleChange = (value) => {
    unregister(unregisteredNames);
    field.onChange(value);
  };

  return (
    <Field.Memoized
      type={Field.types.select}
      formItemLabel="Что установить"
      required
      value={field.value}
      errorMessage={fieldState.error?.message}
      placeholder="Выбрать из списка"
      onChange={handleChange}
      rootCN={styles.root}
      style={{ width: '100%' }}
    >
      {options.map((option) => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Field.Memoized>
  );
};

export default SelectDateSetting;
